<template>
  <div class="ly-card structure">
    <div class="lf">
      <div class="inner">
        <el-tree
          :data="tree"
          draggable
          default-expand-all
          node-key="id"
          ref="tree"
          highlight-current
          :props="defaultProps"
          :expand-on-click-node="false"
          @current-change="handleClick"
          @node-drop="nodeDrop"
          :allow-drop="allowDrop"
        ></el-tree>
        <div class="btn-bottom">
          <el-button type="primary" icon="el-icon-plus" size="small" @click="addStructure">添加组织</el-button>
        </div>
      </div>
    </div>
    <div class="rg">
      <div class="show-list" v-if="choseNode">
        <h3>{{ choseNode.name }}</h3>
        <el-tabs type="border-card" @tab-click="tabClick" v-model="curTab">
          <el-tab-pane name="info" label="基础信息" class="info">
            <ul v-if="!isEditSpecial">
              <li>
                <span class="title">名称</span>
                <span class="content">{{ choseNode.name }}</span>
              </li>
              <li>
                <span class="title">代码</span>
                <span class="content">{{ choseNode.code }}</span>
              </li>
              <li>
                <span class="title">父组织</span>
                <span class="content">{{ getStruName(choseNode.full_name) }}</span>
              </li>
              <li>
                <span class="title">所属地区</span>
                <span class="content">{{ `${choseNode.province_name}/${choseNode.city_name}` }}</span>
              </li>
              <li>
                <span class="title">备注</span>
                <span class="content">{{ choseNode.remarks }}</span>
              </li>
              <li>
                <el-button type="primary" @click="startEdit" size="medium">编辑</el-button>
                <el-button type="danger" size="medium" @click="delStructure">删除</el-button>
              </li>
            </ul>
            <div v-else>
              <ly-form :defaultFormItem="defaultFormItem" :formConfig="formConfig" :formKeys="formKeys" ref="lyForm">
                <template v-slot:province_code="{ formData }">
                  <div class="input-flex">
                    <el-select
                      ref="provinceSelect"
                      @change="value => getCity(value, formData)"
                      v-model="formData.province_code"
                      filterable
                      placeholder="所属省份"
                    >
                      <el-option
                        v-for="item in province"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                    <el-select ref="citySelect" v-model="formData.city_code" filterable placeholder="所属城市">
                      <el-option
                        v-for="item in city"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                  </div>
                </template>
                <template v-slot:city_code></template>
              </ly-form>
              <el-button type="primary" @click.native="saveForm" size="medium">保存</el-button>
              <el-button size="medium" @click.native="cancelSave">取消</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane name="special" label="项目设置" v-if="choseNode && choseNode.id !== -1">
            <div class="special-hd m-b-20">
              <el-button @click="addSpecialDg" type="primary" size="medium">添加项目</el-button>
              <el-button @click="removeBathRow" type="danger" size="medium" :disabled="!selection.length"
                >批量移出项目</el-button
              >
            </div>
            <ly-table
              :getTableData="getTableData"
              :tableConfig="tableConfig"
              :tableHeader="tableHeader"
              :searchFormData="searchFormData"
              ref="lyTable"
            >
              <template v-slot:action="row">
                <el-button @click="removeRow(row)" type="danger" size="mini">移出</el-button>
              </template>
            </ly-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog title="添加更多项目" :visible.sync="dialogVisible" width="650px" @closed="reset">
      <div class="body">
        <special-search
          v-if="dialogVisible"
          :id="choseNode && Number(choseNode.id)"
          @result-data="searchData"
          ref="specialSearch"
        />
        <el-checkbox
          v-model="selectAll"
          @change="selectAllChange"
          v-if="specialSearchResult.length"
          :indeterminate="indeterminate"
          border
          class="m-t-10"
          >全选</el-checkbox
        >
        <br />
        <el-checkbox
          :label="item.id"
          v-model="item.checked"
          @change="value => checkChange(value, item)"
          border
          v-for="item in specialSearchResult"
          :key="item.id"
          class="check-box m-t-20 m-l-0"
          >{{ item.name }}</el-checkbox
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveSpecial">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Checkbox, Dialog, Tabs, TabPane, Tree, Select, Option } from 'element-ui';
import { base } from '@/api';
import LyTable from '@/components/LyTable';
import LyForm from '@/components/LyForm';
import SpecialSearch from '@/components/SpecialSearch';
import { specialTable } from '@/utils/tableHeader';
import { specialFormItem } from '@/utils/formConfig';
// import pattern from '@/utils/pattern';

export default {
  name: 'structure',
  components: {
    ElTree: Tree,
    LyTable,
    LyForm,
    SpecialSearch,
    ElTabs: Tabs,
    ElTabPane: TabPane,
    ElDialog: Dialog,
    ElCheckbox: Checkbox,
    ElSelect: Select,
    ElOption: Option
  },
  data() {
    return {
      tree: [],
      defaultProps: {
        label: 'name'
      },
      dialogVisible: false,
      choseNode: null,
      searchFormData: {},
      specialSearchResult: [],
      checkList: [],
      selection: [],
      tableConfig: {
        action: {
          'selection-change': selection => {
            this.selection = selection;
          }
        }
      },
      curTab: 'info',
      tabCache: false,
      isEditSpecial: false, // 是否编辑部门
      tempStructureData: null, // 编辑时暂存
      formConfig: {
        'label-width': '100px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      },
      formKeys: specialFormItem,
      defaultFormItem: null,
      tableHeader: specialTable,
      province: [],
      city: [],
      checkAddList: {},
      checkDelList: {},
      allowDrop(draggingNode, dropNode, type) {
        if (type === 'inner') return false;
        if (draggingNode.data.parent_id !== dropNode.data.parent_id) return false;
        return true;
      },
      selectAll: false
    };
  },
  computed: {
    indeterminate() {
      const { checked } = this.specialSearchResult[0];
      return !this.specialSearchResult.every(item => item.checked === checked);
    }
  },
  mounted() {
    this.getTree();
  },
  methods: {
    addSpecialDg() {
      this.dialogVisible = true;
    },
    getStruName(full_name) {
      if (full_name) {
        const org_names = full_name.match(/^(.*)[/]/);
        if (org_names) return org_names[1];
        return full_name;
      }
      return '';
    },
    getTableData(params) {
      return base.getTableByOrg({
        id: this.choseNode.id,
        params
      });
    },
    async getTree(defData) {
      const res = await base.structureTree({ methold: 'get' });
      if (res && res.data) {
        this.tree = res.data.tree;
        const temp = defData || res.data.tree[0];
        this.$nextTick(() => {
          if (this.$refs.tree) this.$refs.tree.setCurrentKey(temp.id);
        });
        this.handleClick(temp);
      }
    },
    async getCity(province_code, formData) {
      const res = await base.getCity({
        province_code
      });
      if (res && res.data) {
        if (formData) {
          /* eslint-disable no-param-reassign */
          formData.city_code = '';
          formData.city_name = '';
        }
        this.city = Object.freeze(res.data.list);
      }
    },
    async getProvince() {
      if (this.province.length) return;
      const res = await base.getProvince();
      if (res && res.data) {
        this.province = Object.freeze(res.data.list);
      }
    },
    startEdit() {
      this.isEditSpecial = true;
      this.defaultFormItem = {
        ...this.choseNode,
        org_id: this.choseNode.id,
        org_name: this.getStruName(this.choseNode.full_name)
      };
      this.getProvince();
      this.getCity(this.choseNode.province_code);
    },
    async addStructure() {
      this.isEditSpecial = true;
      this.curTab = 'info';
      this.choseNodeTmp = { ...this.choseNode };
      this.choseNode = {
        name: '新增部门',
        id: -1,
        parent_id: this.choseNode ? this.choseNode.parent_id : null
      };
      await this.getProvince();
      await this.getCity(this.province[0].code);
      this.defaultFormItem = {
        province_code: this.province[0].code,
        city_code: this.city[0].code,
        org_id: this.tree[0].id,
        org_name: this.tree[0].name
      };
    },
    cancelSave() {
      this.isEditSpecial = false;
      this.tempStructureData = null;
      if (this.choseNode && this.choseNode.id === -1) {
        if (this.choseNodeTmp.id) this.choseNode = { ...this.choseNodeTmp };
        else this.choseNode = null;
      }
    },
    async saveForm() {
      const validObj = await this.$refs.lyForm.getFormData();
      if (validObj && validObj.valid && validObj.data) {
        let res = null;
        if (this.defaultFormItem && this.choseNode.id !== -1) {
          // 编辑
          res = await base.controlStructure({
            id: this.choseNode.id,
            params: {
              ...validObj.data,
              city_name: this.$refs.citySelect.selectedLabel,
              province_name: this.$refs.provinceSelect.selectedLabel,
              parent_id: this.choseNode.parent_id || undefined
            },
            methold: 'put'
          });
        } else {
          // 新增
          res = await base.structureTree({
            params: {
              parent_id: this.choseNodeTmp.id,
              ...validObj.data,
              city_name: this.$refs.citySelect.selectedLabel,
              province_name: this.$refs.provinceSelect.selectedLabel
            },
            methold: 'post'
          });
        }
        if (res && res.data && res.data.org) {
          this.$message.success(res.msg || '操作成功！');
          this.isEditSpecial = false;
          this.choseNode = null;
          await this.getTree({
            id: res.data.org.id,
            is_top_org: res.data.org.id,
            name: res.data.org.name,
            parent_id: res.data.org.parent_id
          });
        }
      }
    },
    searchData(data) {
      this.specialSearchResult = data.map(item => {
        const temp = { ...item };
        if (this.checkAddList[temp.id]) temp.checked = true;
        if (this.checkDelList[temp.id]) temp.checked = false;
        return temp;
      });
      this.selectAll = this.specialSearchResult.every(cur => cur.checked);
    },
    async handleClick(data) {
      this.isEditSpecial = false;
      if (this.$refs.lyTable) this.$refs.lyTable.clearData();
      this.defaultFormItem = null;
      const res = await base.controlStructure({ id: data.id, methold: 'get' });
      if (res && res.data) {
        this.choseNode = res.data.org;
        this.searchFormData.id = data.id;
        this.tabCache = false;
        if (this.curTab === 'special') {
          this.search();
        }
      }
    },
    tabClick() {
      if (this.curTab === 'special' && this.searchFormData.id && !this.tabCache) {
        this.tabCache = true;
        this.search();
      }
    },
    async removeRow(row) {
      this.removeBathRow([row.id]);
    },
    async saveSpecial() {
      const res = await base.batchAddSpecialByOrg({
        org_id: this.choseNode.id,
        params: {
          create_ids: Object.keys(this.checkAddList),
          delete_ids: Object.keys(this.checkDelList)
        }
      });
      if (res) {
        this.$message.success(res.msg || '修改成功');
        this.checkDelList = {};
        this.checkAddList = {};
        this.specialSearchResult = [];
        this.dialogVisible = false;
        this.search();
      }
    },
    delStructure() {
      this.$confirm(`确认删除组织-${this.choseNode.name}`)
        .then(() => {
          base
            .controlStructure({
              id: this.choseNode.id,
              methold: 'delete'
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '删除成功');
                this.getTree();
                this.choseNode = null;
              }
            });
        })
        .catch(() => {});
    },
    async removeBathRow(delete_ids) {
      if (!(delete_ids instanceof Array)) delete_ids = this.selection.map(item => item.id);
      const res = await base.batchDelSpecialByOrg({
        org_id: this.choseNode.id,
        params: {
          delete_ids
        }
      });
      if (res) {
        this.$message.success(res.msg || '移出成功');
        this.search();
      }
    },
    reset() {
      this.checkAddList = {};
      this.checkDelList = {};
      this.specialSearchResult = [];
      if (this.$refs.specialSearch) this.$refs.specialSearch.reset();
    },
    search() {
      this.$refs.lyTable.setData();
    },
    checkChange(value, item, isSelectAll) {
      if (value) {
        if (this.checkDelList[item.id]) {
          const temp = { ...this.checkDelList };
          delete temp[item.id];
          this.checkDelList = temp;
        } else {
          this.checkAddList[item.id] = true;
        }
      } else if (this.checkAddList[item.id]) {
        const temp = { ...this.checkAddList };
        delete temp[item.id];
        this.checkAddList = temp;
      } else {
        this.checkDelList[item.id] = true;
      }
      if (isSelectAll !== true) {
        this.selectAll = this.specialSearchResult.every(cur => cur.checked);
      }
    },
    selectAllChange(value) {
      this.specialSearchResult.map(item => {
        if (item.checked !== value) {
          item.checked = value;
          this.checkChange(value, item, true);
        }
        return item;
      });
    },
    nodeDrop(curNode, endNode, position) {
      let id = -1;
      if (position === 'before') {
        id = endNode.previousSibling.previousSibling ? endNode.previousSibling.previousSibling.data.id : -1;
      }
      if (position === 'after') {
        ({ id } = endNode.data);
      }
      base
        .orgOrder({
          params: {
            org_id: curNode.data.id,
            previous_org_id: id
          }
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '更新成功！');
          }
        });
    }
  }
};
</script>
<style lang="less">
.structure {
  display: flex;
  height: calc(100vh - @navBarTopHeight - @navBarTagsHeight - 10px);
  overflow: auto;
  .lf {
    width: 220px;
    min-width: 220px;
    height: 100%;
    background: #fff;
    border-right: 1px solid #ccc;
    overflow: hidden;
    position: relative;
    padding-bottom: 40px;
    padding-right: 10px;
    .inner {
      height: 100%;
      overflow: auto;
    }
    .el-tree {
      background: inherit;
    }
    .btn-bottom {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      text-align: center;
    }
  }
  .rg {
    flex: 1;
    margin-left: 10px;
    max-width: calc(100% - 230px);
    .show-list .info {
      ul {
        li {
          list-style: none;
          margin: 20px 0;
          > .title {
            display: inline-block;
            min-width: 100px;
            font-size: 16px;
          }
          .content {
            color: #333;
            font-size: 14px;
          }
        }
      }
    }
    .input-flex {
      display: flex;
      .el-input {
        margin-right: 20px;
        width: 202px;
      }
    }
  }
  .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #66b1ff;
    color: #fff;
  }
}
</style>
